<script>
import { Userpilot } from 'userpilot'
import { mapGetters } from 'vuex'

import Loading from './Loading'
import CloudflareChallenge from '~/components/cloudflare-challenge/CloudflareChallenge.vue'
import EventBus from '~/EventBus'
import util from '~/util'


// Load layout components dynamically.
const layoutModules = import.meta.glob('../layouts/*.vue', { eager: true })

const layouts = Object.entries(layoutModules).reduce((components, [path, module]) => {
  const name = path.replace(/^.*\/(.*)\.vue$/, '$1')
  components[name] = module.default || module
  return components
}, {})

export default {
  el: '#app',

  components: {
    CloudflareChallenge,
    Loading,
  },

  data: () => ({
    layout: null,
    defaultLayout: 'default',
    requestFrom: '',
    isShowCloudflareChallenge: false,
  }),

  computed: {
    ...mapGetters({
      activeStore: 'auth/activeStore',
    }),
  },
  metaInfo() {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`,
    }
  },

  mounted() {
    this.$loading = this.$refs.loading

    let urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('from') && urlParams.get('from') === 'extension') {
      this.requestFrom = urlParams.get('from')
    }

    EventBus.$on('show-cloudflare-challenge', this.showCloudflareChallenge)
    EventBus.$on('close-cloudflare-challenge', this.closeCloudflareChallenge)
  },

  beforeDestroy() {
    EventBus.$off('show-cloudflare-challenge', this.showCloudflareChallenge)
    EventBus.$off('close-cloudflare-challenge', this.closeCloudflareChallenge)
  },

  methods: {
    showCloudflareChallenge() {
      this.isShowCloudflareChallenge = true
    },

    closeCloudflareChallenge() {
      this.isShowCloudflareChallenge = false
    },

    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    },

    getPlanName(user) {
      if (user.is_free_user) {
        return 'Free'
      } else if (user.is_pro_user) {
        return 'Pro'
      } else if (user.is_plus_user) {
        return 'Plus'
      } else if (user.is_select_user) {
        return 'Private Agent'
      }
      return ''
    },

    loginToChromeExtension(userEmail) {
      // send login request to chrome extension
      window.postMessage({ type: 'LOGIN_TO_EXTENSION', email: userEmail }, '*')
    },

    syncUserpilot(user) {
      if (user) {
        Userpilot.identify(user.id, {
          name: user.name,
          email: user.email,
          created_at: user.created_at,
          role: this.$root.getPlanName(user),
          plan_interval: user.plan,
          branding: this.activeStore?.store_settings?.branding ? 'On' : 'Off',
          daily_fulfillment: this.activeStore?.store_settings?.dailyfulfill ? 'On' : 'Off',
          auto_fulfillment: this.activeStore?.store_settings?.autofulfill ? 'On' : 'Off',
          phone_number: user.phone,
          claimed_monthly_revenue: user.claimed_monthly_revenue,
          store_url: this.activeStore?.store_url,
          marketing_deal_tag: user.marketing_deal_tag,
          signed_up_through: user.signed_up_through,
        })
      }
    },
  },
}
</script>

<template>
  <div id="app">
    <loading ref="loading" />

    <transition name="page" mode="out-in">
      <component :is="layout" v-if="layout" />
    </transition>

    <cloudflare-challenge v-if="isShowCloudflareChallenge" />
  </div>
</template>
